<ng-template #iframeForm>
  <div class="modal-body">
    <div *ngIf="trustedUrl">
      <iframe [src]="trustedUrl" width="100%" height="500px"></iframe>
    </div>
    <div *ngIf="displayCounter">
      <p>Time remaining: {{ counter }} seconds</p>
    </div>
    <div *ngIf="validationError">
      <p class="text-danger">{{ alertContent }}</p>
    </div>
  </div>
</ng-template>
